import angular from 'angular';

angular
  .module('cloudX')
  .controller('TranslateListItemDialogCtrl', [
    '$element',
    '$http',
    '$q',
    '$scope',
    '$translate',
    'flySvc',
    'appUrls',
    'close',
    'list',
    'listid',
    'fallback',
    'options',
    translateListItemDialogCtrl,
  ]);

function translateListItemDialogCtrl(
  $element,
  $http,
  $q,
  $scope,
  $translate,
  flySvc,
  appUrls,
  close,
  list,
  listid,
  fallback,
  options,
) {
  var vm = this;
  vm.fallback = fallback;
  vm.accessor = {};

  vm.translations = [];
  vm.list = list;
  vm.listid = listid;

  vm.options = options;

  vm.saving = false;
  vm.save = function() {
    if (vm.saving) return;
    if (!vm.accessor.isValid || !vm.accessor.isValid()) return;
    if (!vm.accessor.save) return;

    vm.saving = true;
    vm.accessor
      .save()
      .then(function(changes) {
        const defaultChanged = changes.find(x => x.isTenantLanguage);
        close({ defaultValue: defaultChanged ? defaultChanged.value : null, changes }, 500);
        $element.modal('hide');
      })
      .finally(() => {
        vm.saving = false;
      });
  };
  vm.cancel = function() {
    vm.saving = false;
    close(null, 500);
  };
}
